import React, 
       { useState, 
         useContext, 
         useEffect }   from 'react';
import { Card, 
         Form, 
         Button, 
         Container, 
         Row, 
         Col         } from 'react-bootstrap';
import api             from './AxiosConfig';
import { AuthContext } from './AuthContext';

function AdminUsers() {
    const { isLoggedIn,
            isAdmin     }                     = useContext(AuthContext);
    const [message,        setMessage]        = useState('');
    const [messageError,   setMessageError]   = useState( false );
    const [expandedUser,   setExpandedUser]   = useState( -1 );
    const [userList,       setUserList]       = useState( [] );
    const [usersChanged,   setUsersChanged]   = useState( true );
       
    useEffect(() => {
        async function getUserList() {
            try {
                if ( isLoggedIn && usersChanged) {
                    const response = await api.get('/site/users/summary', {withCredentials: true});
                    if (response.status === 201) {
                        setUserList( response.data.users );
                    }
                    setUsersChanged( false );
                }
            } catch (error) {
                 console.log("Error" + error );
            }
        }

        getUserList();
    }, [usersChanged, isLoggedIn]);
       
    const handleChangeUser = (i, event) => {
        const name  = event.target.name;
        const value = event.target.value;
        console.log("handleChangeUser(" + i + ") " + name + " = " + value);
        setUserList( prevValues => {
            const updated = [...prevValues];
            var userRec = updated[i];
            userRec[name] = value;
            updated[i] = userRec;
            return updated;
            });
    };

    const handleSubmitUsers = async (e) => {
        e.preventDefault();
        console.log("submit: user=" + JSON.stringify(userList[expandedUser]));
        if ( expandedUser >= 0 ) {
            const response = await api.put(`/site/users/admin-edit/${userList[expandedUser].id}`, {userRecord: userList[expandedUser]}, { withCredentials: true });
            setMessage( response.data.message );
            setMessageError( !response.data.success );
        }
    }
       
    const handleExpand = ( i ) => {
        if ( expandedUser === i ) {
            setExpandedUser( -1 );
        } else {
            setExpandedUser( i );
        }
    }
       
    return (
      <Card>
      <Card.Header className="card-goal-header">
        <Card.Title>
          <div class="content-container">
            <div class="left-content d-flex align-items-center">
              Admin
            </div>
            <div class="right-content">
               <></>
            </div>
          </div>
        </Card.Title>
        <Card.Subtitle className="text-center">Admin - Users</Card.Subtitle>
      </Card.Header>
      <Card.Body className="p-0" >
        <Container className="mt-4">
                    <Form onSubmit={handleSubmitUsers}>
                        {  userList.map( ( u, i ) => (<>
                        <div onClick={() => handleExpand( i )}>{u.email}</div>
                            { expandedUser === i && ( <>        
                        <Form.Group as={Row} className="mb-3" controlId={u.key}>
                            <Form.Label column className="text-end">First Name</Form.Label>
                            <Col>
                                <Form.Control
                                type="text"
                                name="first_name"
                                value={u.first_name}
                                onChange={(e) => handleChangeUser( i, e )}
                            />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId={u.key}>
                            <Form.Label column className="text-end">First Name</Form.Label>
                            <Col>
                                <Form.Control
                                type="text"
                                name="last_name"
                                value={u.last_name}
                                onChange={(e) => handleChangeUser( i, e )}
                            />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId={u.key}>
                            <Form.Label column className="text-end">Admin</Form.Label>
                            <Col>
                                <Form.Control
                                type="text"
                                name="is_admin"
                                value={u.is_admin}
                                onChange={(e) => handleChangeUser( i, e )}
                            />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId={u.key}>
                            <Form.Label column className="text-end">User Type</Form.Label>
                            <Col>
                                <Form.Control
                                type="text"
                                name="user_type"
                                value={u.user_type}
                                onChange={(e) => handleChangeUser( i, e )}
                            />
                            </Col>
                        </Form.Group>
                        {/* Submit Button */}
                        <Form.Group as={Row} className=" text-center mt-4">
                        <Col>
                        <Button variant="primary" type="submit">
                            Update
                        </Button>
                        </Col>
                        </Form.Group>
                                    
                        </> )}
                        </>))}    
                    </Form>
                               
                    <Row><Col className={'text-center message-err-' + messageError }>{message}</Col></Row>
        </Container>
        </Card.Body>
      </Card>
    );
}

export default AdminUsers;
